import { render, staticRenderFns } from "./CentroFuncionalBadge.vue?vue&type=template&id=14cbe8c4"
import script from "./CentroFuncionalBadge.vue?vue&type=script&lang=js"
export * from "./CentroFuncionalBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports